(function (window, document) {
  "use strict";

  var DNB = (window.DNB = window.DNB || {});

  var DEFAULT_DURATION = 5000; // ms — slaytta data-duration yoksa
  var DEFAULT_LINK = "javascript:;";

  DNB.HomeHero = {
    init: function () {
      var root = document.querySelector("[data-hero]");
      if (!root || root.getAttribute("data-hero-init") === "1") return;
      root.setAttribute("data-hero-init", "1");

      var slides = root.querySelectorAll("[data-hero-slide]");
      var loader = root.querySelector("[data-hero-loader]");
      if (!slides.length) return;

      // ---- Controller'ı slayt verilerinden tamamen JS ile oluştur ----
      var controller = document.createElement("div");
      controller.className = "home-hero__controller";
      controller.innerHTML =
        '<div class="home-hero__progress-track"><span class="home-hero__progress-bar" data-hero-progress></span></div>' +
        '<div class="home-hero__controller-body">' +
          '<div class="home-hero__counter">' +
            '<span class="home-hero__counter-num" data-hero-num></span>' +
            '<a class="home-hero__counter-label" data-hero-label></a>' +
          '</div>' +
          '<div class="home-hero__nav">' +
            '<button class="home-hero__nav-btn" type="button" data-hero-prev aria-label="Önceki"><span class="icon icon--arrow-left" aria-hidden="true"></span></button>' +
            '<button class="home-hero__nav-btn" type="button" data-hero-next aria-label="Sonraki"><span class="icon icon--arrow-right" aria-hidden="true"></span></button>' +
          '</div>' +
        '</div>';
      root.appendChild(controller);

      var numEl = controller.querySelector("[data-hero-num]");
      var labelEl = controller.querySelector("[data-hero-label]");
      var bar = controller.querySelector("[data-hero-progress]");
      var prev = controller.querySelector("[data-hero-prev]");
      var next = controller.querySelector("[data-hero-next]");

      var current = 0;
      var timer = null;
      var tween = null;

      // ---- Slayt verilerini data-attr'lardan oku (fallback'li) ----
      function getDuration(slide) {
        var raw = parseFloat(slide.getAttribute("data-duration"));
        return (raw && raw > 0) ? raw * 1000 : DEFAULT_DURATION;
      }
      function getLabel(slide) {
        var label = slide.getAttribute("data-label");
        if (label) return label;
        var title = slide.querySelector(".home-hero__title");
        return title ? title.textContent.trim() : "";
      }
      function getLink(slide) {
        return slide.getAttribute("data-label-link") || DEFAULT_LINK;
      }

      function hideLoader() {
        if (loader) loader.classList.add("is-hidden");
      }

      function waitMedia(slide, cb) {
        var v = slide.querySelector("video");
        var img = slide.querySelector("img");
        if (v) {
          if (v.readyState >= 3) return cb();
          v.addEventListener("loadeddata", cb, { once: true });
          v.addEventListener("error", cb, { once: true });
        } else if (img) {
          if (img.complete) return cb();
          img.addEventListener("load", cb, { once: true });
          img.addEventListener("error", cb, { once: true });
        } else cb();
      }

      function startProgress() {
        if (timer) clearTimeout(timer);
        if (tween) tween.kill();
        var dur = getDuration(slides[current]);

        if (bar && window.gsap) {
          window.gsap.set(bar, { scaleX: 0 });
          tween = window.gsap.to(bar, {
            scaleX: 1,
            duration: dur / 1000,
            ease: "none",
            onComplete: function () { go(current + 1); }
          });
        } else {
          timer = setTimeout(function () { go(current + 1); }, dur);
        }
      }

      function go(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          slide.classList.toggle("is-active", i === current);
          var v = slide.querySelector("video");
          if (v) {
            if (i === current) { try { v.currentTime = 0; v.play(); } catch (e) {} }
            else v.pause();
          }
        });
        if (numEl) numEl.textContent = (current + 1) + "/" + slides.length;
        if (labelEl) {
          labelEl.textContent = getLabel(slides[current]);
          labelEl.setAttribute("href", getLink(slides[current]));
        }
        startProgress();
      }

      waitMedia(slides[0], hideLoader);
      go(0);

      if (prev) prev.addEventListener("click", function () { go(current - 1); });
      if (next) next.addEventListener("click", function () { go(current + 1); });
    }
  };
})(window, document);
